import updateNotes from '../Services/updateNotes'
import { closeNotesModal } from '../State/notesModal'

export default (notes) => async (dispatch) => {

  if (notes !== undefined) {
    await dispatch(updateNotes(notes))
  }

  dispatch(closeNotesModal())

}
